import React from 'react';
import LeadershipChrome from '@/components/LeadershipChrome';
import { PHARMACY_MENU } from '@/config/navigationMenus';
import { LEADERSHIP_CONTENT } from '@/config/leadershipLayout';

/** Pharmacy shell — FIC-style campus chrome (non-admin). */
export default function PharmacyCampusShell({ children, pageTitle, pageSubtitle, rightActions }) {
  return (
    <LeadershipChrome homeHref="/pharmacy" roleLabel="Pharmacy" menuItems={PHARMACY_MENU}>
      <div className={LEADERSHIP_CONTENT} data-testid="pharmacy-campus-shell">
        {(pageTitle || rightActions) ? (
          <div className="flex flex-wrap items-end justify-between gap-3 mb-5">
            <div>
              {pageTitle ? (
                <h1 className="text-2xl font-semibold text-[#071B34] font-heading">{pageTitle}</h1>
              ) : null}
              {pageSubtitle ? <p className="text-sm text-[#5A6B7C] mt-1">{pageSubtitle}</p> : null}
            </div>
            {rightActions}
          </div>
        ) : null}
        {children}
      </div>
    </LeadershipChrome>
  );
}
